import cssVars from "css-vars-ponyfill";

function getRelativeUrl(url) {
  let newUrl = url;

  // URL is already absolute;
  if (newUrl.includes("://")) {
    const slashesIndex = newUrl.indexOf("://");
    const endOfOrigin = newUrl.indexOf("/", slashesIndex + "://".length);

    newUrl = newUrl.slice(endOfOrigin);
  }

  return newUrl;
}

export default () => {
  /**
   * Determine if this browser supports CSS vars natively.
   * This is the same logic used by the `cssVars` package.
   */
  const hasCSSVarSupport =
    typeof window !== "undefined" &&
    window.CSS &&
    window.CSS.supports &&
    window.CSS.supports("(--a: 0)");

  return new Promise(resolve => {
    if (hasCSSVarSupport) {
      resolve();
    } else {
      cssVars({
        include: "[data-css-vars]",
        onBeforeSend(xhr, elm, url) {
          /**
           * cssVars does an AJAX request for any CSS files loaded by a <link> tag,
           * including the `master.css` file we want to include.
           *
           * This file is hosted on cloudfront, so has a different domain than the campaign;
           * in order to prevent this AJAX request from getting rejected by CORS, we need cssVars
           * to use the same domain as the campaign.
           *
           * WARNING: this will break the ponyfill functionality for any <link> tag including
           * a css file not served from p2a.
           */
          xhr.open("GET", getRelativeUrl(url), true);
        },
        onComplete: resolve
      });
    }
  });
};
